module.exports = __webpack_public_path__ + "build/desktop/img/star.52ccfc0e846cf44478498af410dd8e86.svg";